import { Controller } from "@hotwired/stimulus"

// Rate-card estimate: $/h for agent + human (split) or a single standalone
// rate that sets both. Computes a live quoted-dollar preview from the quoted
// hours; the model re-derives quoted_dollars server-side on save.
export default class extends Controller {
  static targets = [
    "rateMode",
    "standaloneField",
    "splitFields",
    "standaloneRate",
    "agentRate",
    "humanRate",
    "quotedAgentHours",
    "quotedHumanHours",
    "quotedDollars"
  ]

  connect() {
    this.recalculate()
  }

  recalculate() {
    const selectedMode = this.rateModeTargets.find((input) => input.checked)
    const mode = selectedMode?.value || "standalone"
    this.toggle(mode)

    const standaloneRate = this.num(this.standaloneRateTarget.value)
    const agentRate = mode === "standalone" ? standaloneRate : this.num(this.agentRateTarget.value)
    const humanRate = mode === "standalone" ? standaloneRate : this.num(this.humanRateTarget.value)
    const agentHours = this.num(this.quotedAgentHoursTarget.value)
    const humanHours = this.num(this.quotedHumanHoursTarget.value)
    const dollars = agentHours * agentRate + humanHours * humanRate

    if (this.hasQuotedDollarsTarget) {
      this.quotedDollarsTarget.textContent = Number.isFinite(dollars) ? `$${dollars.toFixed(2)}` : "$0.00"
    }
  }

  toggle(mode) {
    if (this.hasStandaloneFieldTarget) {
      const hidden = mode !== "standalone"
      this.standaloneFieldTarget.classList.toggle("hidden", hidden)
      this.standaloneFieldTarget.setAttribute("aria-hidden", hidden)
    }
    if (this.hasSplitFieldsTarget) {
      const hidden = mode !== "split"
      this.splitFieldsTarget.classList.toggle("hidden", hidden)
      this.splitFieldsTarget.setAttribute("aria-hidden", hidden)
    }
  }

  num(value) {
    const n = parseFloat(value)
    return Number.isFinite(n) ? n : 0
  }
}
